import { useTranslation } from '@utils/i18n/i18n.consumers';
import { Icon } from '@nazka/nazka.mapframe.components'
import { faDroplet, faTemperatureHigh, faWind } from '@fortawesome/pro-light-svg-icons'
import {
  faCloudShowers,
  faFire,
  faHandHoldingDroplet,
  faTemperatureSun,
  faWindWarning,
} from '@fortawesome/pro-solid-svg-icons';
import theme from '@css/theme.style.json';

import './risk-data-info-table.styl';

function RiskDataInfoTable() {
  const { t } = useTranslation();

  return (
    <table className="risk-data-info-table">
      <thead>
        <tr>
          <th scope="col">{t('Type')}</th>
          <th scope="col">{t('Hazard category')}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <div className="risk-data-info-table__type">
              <span className="risk-data-info-table__type-label">{t('Temperature')}</span>
              <Icon icon={faTemperatureHigh} size="20px" color={theme.color.primary.main} className="risk-data-info-table__icon" />
            </div>
          </td>
          <td>
            <div className="risk-data-info-table__hazards">
              <div className="risk-data-info-table__hazard">
                <Icon icon={faFire} size="20px" color={theme.color.primary.main} className="risk-data-info-table__icon" />
                <span className="risk-data-info-table__hazard-text">{t('Fire')}</span>
              </div>
              <div className="risk-data-info-table__hazard">
                <Icon icon={faTemperatureSun} size="20px" color={theme.color.primary.main} className="risk-data-info-table__icon" />
                <span className="risk-data-info-table__hazard-text">{t('Heat wave')}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="risk-data-info-table__type">
              <span className="risk-data-info-table__type-label">{t('Water')}</span>
              <Icon icon={faDroplet} size="20px" color={theme.color.primary.main} className="risk-data-info-table__icon" />
            </div>
          </td>
          <td>
            <div className="risk-data-info-table__hazards">
              <div className="risk-data-info-table__hazard">
                <Icon icon={faCloudShowers} size="20px" color={theme.color.secondary.main} className="risk-data-info-table__icon" />
                <span className="risk-data-info-table__hazard-text">{t('Extreme rainfall')}</span>
              </div>
              <div className="risk-data-info-table__hazard">
                <Icon icon={faHandHoldingDroplet} size="20px" color={theme.color.primary.main} className="risk-data-info-table__icon" />
                <span className="risk-data-info-table__hazard-text">{t('Dry spells')}</span>
              </div>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div className="risk-data-info-table__type">
              <span className="risk-data-info-table__type-label">{t('Wind')}</span>
              <Icon icon={faWind} size="20px" color={theme.color.primary.main} className="risk-data-info-table__icon" />
            </div>
          </td>
          <td>
            <div className="risk-data-info-table__hazards">
              <div className="risk-data-info-table__hazard">
                <Icon icon={faWindWarning} size="20px" color={theme.color.primary.main} className="risk-data-info-table__icon" />
                <span className="risk-data-info-table__hazard-text">{t('Extreme wind')}</span>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

export default RiskDataInfoTable;
